// removed by extract-text-webpack-plugin
module.exports = {"ant-dropdown-link":"index__ant-dropdown-link___2MNJX","lang-dropdown-menu":"index__lang-dropdown-menu___DWT9I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/LanguageDropdown/index.less
// module id = 1251
// module chunks = 3